import { addLocaleMessages } from '@/i18n';
import zhCN from './locales/zh-CN';
import zhTW from './locales/zh-TW';
import enUS from './locales/en-US';
import jaJP from './locales/ja-JP';

addLocaleMessages('cn', zhCN);
addLocaleMessages('tw', zhTW);
addLocaleMessages('en', enUS);
addLocaleMessages('jp', jaJP);
